// extracted by mini-css-extract-plugin
export default {"base":"Base_base__lQNt+","base_canvas":"Base_base_canvas__gQIpa","description":"Base_description__UbaBS","blink":"Base_blink__iPZis"};